var map = {
	"./01.jpg": 68300,
	"./010.jpg": 83966,
	"./011.jpg": 55099,
	"./012.jpg": 12300,
	"./013.jpg": 74025,
	"./014.jpg": 72186,
	"./015.jpg": 66647,
	"./016.jpg": 32424,
	"./02.jpg": 11099,
	"./03.jpg": 90942,
	"./04.jpg": 33829,
	"./05.jpg": 6216,
	"./06.jpg": 28535,
	"./07.jpg": 76602,
	"./08.jpg": 23329,
	"./09.jpg": 33380,
	"./default-skin.png": 41022,
	"./default-skin.svg": 35962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45717;